// @flow
import type { TravelActionType } from './actions';
import type { CountryType } from '../../../config/iddCountries';

export default (state: TravelStateType = {}, action: TravelActionType): TravelStateType => {
  switch (action.type) {
    case 'SET_TRAVEL_COUNTRY':
      return {
        ...state,
        country: action.payload.country,
      };
    default:
      return state;
  }
};

export type TravelStateType = {
  country?: CountryType,
};
